import {ProductData} from '@treez/commons/sharedTypings/product';
import {ReducerActionAttributes} from '~/redux/reducers/RootReducer';

export enum ProductMetaDataAction {
    UPDATE_CATALOG_ATTRIBUTES = 'UPDATE_CATALOG_ATTRIBUTES',
    GET_OFFICIAL_BRANDS_FROM_BRANDTREEZ = 'GET_OFFICIAL_BRANDS_FROM_BRANDTREEZ',
    CLEAR_PRODUCT_META_DATA_STATE = 'CLEAR_PRODUCT_META_DATA_STATE',
}

const {
    UPDATE_CATALOG_ATTRIBUTES,
    GET_OFFICIAL_BRANDS_FROM_BRANDTREEZ,
    CLEAR_PRODUCT_META_DATA_STATE,
} = ProductMetaDataAction;

type CatalogUniqueValuesUpdate = Partial<Record<ProductData, string[]>>;

export const updateCatalogUniqueValues = (
    value: CatalogUniqueValuesUpdate
): ReducerActionAttributes<ProductMetaDataAction, CatalogUniqueValuesUpdate> => ({
    value,
    type: UPDATE_CATALOG_ATTRIBUTES,
});

export const updateOfficialBrandOptions = (
    value: string[]
): ReducerActionAttributes<ProductMetaDataAction, string[]> => ({
    value,
    type: GET_OFFICIAL_BRANDS_FROM_BRANDTREEZ,
});

export const clearProductMetaData = (): ReducerActionAttributes<
    ProductMetaDataAction,
    undefined
> => ({
    value: undefined,
    type: CLEAR_PRODUCT_META_DATA_STATE,
});
